import React, {Component} from 'react';

import {GOOGLE_MAPS_API_KEY, MAP_STYLE, MOUNTAIN_MEADOW} from './constants';
import styles from './styles.module.scss';
import togeojson from "@mapbox/togeojson";
import {DetailType} from '~screens/Dashboard/screens/ProjectsIIRSA/screens/ProjectDetail/types';
import JSZip from "jszip";

interface Props {
    project: DetailType
}

interface State {
    paths: string | null;
    markers: string | null;
    polygons: string | null;
}

// TODO i will need all the comented lines once the asstes are online
class Map extends Component<Props, State> {
    // its going to be needed once the project is online for the customizable icons
    // const markerIcon = window.location.host + MARKER_IMAGE[infrastructure]; // eslint-disable-line no-unused-vars
    //const zoom = getZoom(points);

    constructor(props) {
        super(props);
        this.state = {
            markers: null,
            paths: null,
            polygons: null
        }
        const gjsonPromise = this.getGeoJSON(this.props.project.kmlSimplified);
        this.setPaths(gjsonPromise);
        this.setMarkers(gjsonPromise);
    }

    getGeoJSON = async (url) => {
        if (url.toLowerCase().endsWith('.kmz')) {
            const response = await fetch(url);
            const blob = await response.blob();
            const zip = new JSZip();
            const zipFile = await zip.loadAsync(blob);
            const kmlFile = Object.keys(zipFile.files).find(f => f.endsWith('.kml'));
            if (kmlFile === undefined) {
                return new Promise((resolve, reject) => {
                    reject('Invalid file type');
                });
            }
            const kmlText = await zipFile.files[kmlFile].async('text');
            let domObj = (new DOMParser()).parseFromString(kmlText, 'text/xml')
            let gjson = togeojson.kml(domObj);
            return gjson;
        }

        const response = await fetch(url);
        const kmlText = await response.text();
        if (url.toLowerCase().endsWith('.kml')) {
            let domObj = (new DOMParser()).parseFromString(kmlText, 'text/xml')
            let gjson = togeojson.kml(domObj);
            return gjson;
        } else if (url.toLowerCase().endsWith('.geojson')) {
            return new Promise((resolve, reject) => {
                resolve(JSON.parse(kmlText));
            });
        }
        return new Promise((resolve, reject) => {
            reject('Invalid file type');
        });
    }

    setPaths = (gjsonPromise) => {
        let paths = '';
        gjsonPromise.then(gjson => {
            gjson.features.forEach(f => {
                if (f.geometry.type == 'LineString') {
                    const currentPath = this.getCurrentPath(f.geometry.coordinates);
                    paths += `&path=color:${MOUNTAIN_MEADOW}%7Cweight:5$%7C${currentPath}`;
                } else if (f.geometry.type == 'MultiLineString') {
                    f.geometry.coordinates.forEach(path => {
                        const currentPath = this.getCurrentPath(path);
                        paths += `&path=color:${MOUNTAIN_MEADOW}%7Cweight:5$%7C${currentPath}`;
                    });
                } else if (f.geometry.hasOwnProperty('geometries')) {
                    f.geometry.geometries.forEach(g => {
                        if (g.type == 'LineString') {
                            const currentPath = this.getCurrentPath(g.coordinates);
                            paths += `&path=color:${MOUNTAIN_MEADOW}%7Cweight:5$%7C${currentPath}`;
                        }
                    });
                }
            });
            this.setState({paths: paths});
        })
    };

    setMarkers = (gjsonPromise) => {
        let markers = '';
        gjsonPromise.then(gjson => {
            gjson.features.forEach(f => {
                if (f.geometry.type == 'Point') {
                    const coor = f.geometry.coordinates;
                    markers += `%7C${coor[1]},${coor[0]}`;
                } else if (f.geometry.hasOwnProperty('geometries')) {
                    f.geometry.geometries.forEach(g => {
                        if (g.type == 'Point') {
                            const coor = g.coordinates;
                            markers += `%7C${coor[1]},${coor[0]}`;
                        }
                    })
                }
            });
            this.setState({...this.state, markers: markers});
            this.setPolygons(gjsonPromise);
        });
    }

    setPolygons = (gjsonPromise) => {
        let polygons = '';
        gjsonPromise.then(gjson => {
            gjson.features.forEach(f => {
                if (f.geometry.type == 'Polygon') {
                    const currentPol = this.getCurrentPath(f.geometry.coordinates[0]);
                    polygons += `&path=color:${MOUNTAIN_MEADOW}%7Cweight:5$%7Cfillcolor%3a${MOUNTAIN_MEADOW}%7C${currentPol}`;
                } else if (f.geometry.hasOwnProperty('geometries')) {
                    f.geometry.geometries.forEach(g => {
                        if (g.type == 'Polygon') {
                            const currentPol = this.getCurrentPath(f.geometry.coordinates[0]);
                            polygons += `&path=color:${MOUNTAIN_MEADOW}%7Cweight:5$%7Cfillcolor%3a${MOUNTAIN_MEADOW}%7C${currentPol}`;
                        }
                    });
                }
            });
            this.setState({polygons: polygons});
        })
    }

    getCurrentPath = (coordinates) => {
        let currentPath = '';
        coordinates.forEach((c, index) => {
            if (index > 100) {
                return;
            }
            if (index > 0) {
                currentPath += '|';
            }
            currentPath += `${c[1]},${c[0]}`;

        });
        return currentPath;
    }

    render() {

        let center = '';
        let zoom = '';
        if (this.props.project.staticCenter) {
            center = `center=${this.props.project.staticCenter.latitude},${this.props.project.staticCenter.longitude}&`;
            zoom = `zoom=${this.props.project.staticCenter.zoom}&`;
        }

        return (
            <img
                className={styles.map}
                src={`https://maps.googleapis.com/maps/api/staticmap?${center}${zoom}&markers=color:${MOUNTAIN_MEADOW
                + this.state.markers}&size=316x316&${this.state.paths}${this.state.polygons}&${MAP_STYLE}&key=${GOOGLE_MAPS_API_KEY}`}
            />
        );
    }
}

export default Map;
